<h2 class="!text-[16px] !font-bold !leading-6">Instructor Verification</h2>
